import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import {Amplify,Auth,Storage} from "aws-amplify";
import * as VueGoogleMaps from "vue2-google-maps";
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

Vue.config.productionTip = false
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBGx0GVYXax5i6Bs3eCglSrUGaIAvKrgXk",
    libraries: "places" // necessary for places input
  }
});
Amplify.configure({
  Auth: {
    userPoolId: "ap-south-1_OChbmWVSE",
    region: "ap-south-1",
    userPoolWebClientId: "7673q81g1h13ttld9dclucoht4",
    identityPoolId: "ap-south-1:4ff56c56-0513-4ba5-9c79-e334d5f6b2a2",
   
  },
  API: {
    "aws_project_region": "ap-south-1",
    "aws_appsync_graphqlEndpoint": "https://lxslt3cma5fktmf35zntfjfj2m.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
  },
  Storage: {
    AWSS3: {
      bucket: 'prznceinformation', //REQUIRED -  Amazon S3 bucket name
      region: 'ap-south-1', //OPTIONAL -  Amazon service region
     
    }
  },
  endpoints: [
    {
      name: "Report_issue",
      endpoint: " https://61fvl4pi50.execute-api.ap-southeast-1.amazonaws.com/dev/",
    },]
});

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')